import React from 'react';
import {observer, inject, Provider, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {ScreenLoader} from '../../components/screen-loader/screen-loader';
import {IHistoryConsoleStore} from './history-console.stores';
import {IAppRootStore} from '../../app.root.store';
import {HistoryConsole} from './HistoryConsole';
import AppLayoutComponent from '../../layouts/main-layout/index';

import '@techsee/techsee-ui-common/lib/_shared/icons.css';

interface HistoryConsoleViewProps {
    historyConsoleStore: IHistoryConsoleStore;
    rootStore: IAppRootStore;
}

@observer
export class HistoryConsoleViewComponent extends TechseeBaseComponent<HistoryConsoleViewProps> {
    renderInternal(): JSX.Element {
        const {historyConsoleStore} = this.props;

        if (!historyConsoleStore) {
            return <ScreenLoader />;
        }

        return (
            <Provider inviteStore={historyConsoleStore}>
                <AppLayoutComponent
                    topBarComponent={null as any}
                    mainContentComponent={HistoryConsole}
                    mainLayoutController={historyConsoleStore.mainLayoutController}
                    inviteFlowManager={historyConsoleStore.inviteFlowManager}
                />
            </Provider>
        );
    }
}

export const HistoryConsoleView = inject(
    'rootStore',
    'historyConsoleStore'
)(HistoryConsoleViewComponent) as IReactComponent;
